const {
  VITE_HARVESTAPP_V2_API_URL: HARVESTAPP_V2_API_URL,
  VITE_HARVESTAPP_PLATFORM_HOST: HARVESTAPP_PLATFORM_HOST,
  VITE_HARVEST_ID_HOST: HARVEST_ID_HOST,
  VITE_SCHEME: SCHEME,
} = import.meta.env

const scheme = SCHEME || 'https'

export const baseUrl = `${scheme}://${HARVESTAPP_PLATFORM_HOST}`
export const idBaseUrl = `${scheme}://${HARVEST_ID_HOST}`
export const apiBaseUrl = `${scheme}://${HARVESTAPP_V2_API_URL}`

const accountsUrlQueryString = new URLSearchParams({
  filter_product: 'harvest',
  return_to: encodeURI(`${baseUrl}/platform/success?v2=true`),
})
export const accountsUrl = `${idBaseUrl}/accounts?${accountsUrlQueryString}`

// If the user has one account,
// /harvest/sign_in will automatically redirect to it
// If the user has many accounts,
// /harvest/sign_in will redirect to the accounts page (accountsUrls)
export const signInUrl = `${idBaseUrl}/harvest/sign_in?${accountsUrlQueryString}`

export const accountUrl = (accountId, returnTo) =>
  `${idBaseUrl}/accounts/${accountId}?return_to=${returnTo}`

export const buildTimesheetUrl = (baseUri) => new URL('/timesheet', baseUri)

export const redirectToDetailedReport = (
  currentAccountId,
  externalItemId,
  externalGroupId,
  externalServiceName
) => {
  const returnTo = new URL('/reports/detailed', baseUrl)
  returnTo.searchParams.set('external_item_id', externalItemId)
  returnTo.searchParams.set('external_group_id', externalGroupId)
  returnTo.searchParams.set('external_service_name', externalServiceName)

  const url = new URL('/accounts', idBaseUrl)
  url.searchParams.set('return_to', returnTo.pathname + returnTo.search)
  url.searchParams.set('account_id', currentAccountId || '')
  url.searchParams.set('filter_product', 'harvest')
  url.searchParams.set('recent_login', true)

  window.location.href = url
}
